import styled from "styled-components";
import SearchIcon from '@material-ui/icons/Search';

export const SearchFrm = styled.form`
    height: 26px;
    width: 240px;
    border-radius: 1px;
    position: relative;
    margin-top: 3px;

    @media screen and (max-width: 767px) {
        display: none;
    }
`

export const SearchInput  = styled.input`
    height: 26px;
    width: 100%;
    line-height: 24px;
    padding: 0 28px 0 10px;
    font-size: 12px;
    color: #727b88;
    border: 1px solid #e1e1e1;
    border-radius: 1px;
    outline: none;
`

export const SearchSubmit = styled.button`
    outline: none;
    cursor: pointer;
    position: absolute;
    background: none;
    border: none;
    right: 0;
    top: 0;
    width: 30px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const SearchIc = styled(SearchIcon)`
    color: #888686;
    font-size: 20px;
`
